import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { toast } from "react-toastify";

import { useRouter } from "components/hooks";
import { get } from "utils/request";

import { getBrandPublicProfile } from "apis/brand";
import { getMagnetDetailURL } from "apis/magnets";

import { useQuery } from "@tanstack/react-query";
import Loading from "components/atoms/Loading";
import { useUserContext } from "components/context/UserContext";
import { ROUTES, TOAST_CONFIG } from "../../constants";
import MagnetPublicProfile from "./MagnetPublicProfile";

function MagnetPage({ setIsSidebarCustomized }: { setIsSidebarCustomized: Dispatch<SetStateAction<boolean>> }) {
  // const [magnetDetails, setMagnetDetails] = useState();
  const [brandWithMagnet, setBrandWithMagnet] = useState<BrandWithMagnets | null>(null);
  const { setCurrentlyViewingMementoId } = useUserContext();

  const router = useRouter();
  // 9AtZNCYDvFPD6rjKfWEiyc
  const {
    brandId,
    magnetId,
    actionType,
    mementoId,
  }: { brandId: string; magnetId: string; actionType: string; mementoId: string } = router.query;

  function handleGetMagnetFailure(errorMessage: string, error: any) {
    toast.error(errorMessage, TOAST_CONFIG);
    if (error.response.status === 404) {
      router.go(`/${ROUTES.NOT_FOUND}`);
      return;
    }
    throw new Error(errorMessage);
  }

  const getMagnetDetails = () =>
    get(getMagnetDetailURL(magnetId), {
      processError: handleGetMagnetFailure,
    });

  const {
    isLoading: isMagnetDetailsLoading,
    error: magnetDetailsError,
    data: magnetDetails,
    isRefetching: isMagnetDetailsRefetching,
    refetch: refetchMagnetDetails,
  } = useQuery({
    queryKey: [magnetId],
    queryFn: getMagnetDetails,
  });

  // Get Brand With Magnets
  async function getBrandDetailsAndMagnetList() {
    try {
      if (!brandId) {
        return;
      }
      const brandDetailsFromAPI = await get(getBrandPublicProfile(brandId));
      if (brandDetailsFromAPI === null) {
        toast.error("Failed to fetch brand details.", TOAST_CONFIG);
      } else {
        setBrandWithMagnet(brandDetailsFromAPI);
      }
    } catch (err) {
      toast.error("Failed to fetch brand details", TOAST_CONFIG);
    }
  }

  useEffect(() => {
    getBrandDetailsAndMagnetList();
  }, [brandId, magnetId]);

  useEffect(() => {
    if (actionType === "POPUP" && mementoId) {
      setCurrentlyViewingMementoId(mementoId);
    }
  }, [actionType, mementoId]);

  if (magnetDetailsError && !magnetDetails) {
    return null;
  }
  return !isMagnetDetailsLoading && brandWithMagnet ? (
    <MagnetPublicProfile
      setIsSidebarCustomized={setIsSidebarCustomized}
      refetchMagnetDetails={refetchMagnetDetails}
      isMagnetDetailsRefetching={isMagnetDetailsRefetching}
      magnetDetails={magnetDetails}
      brandWithMagnet={brandWithMagnet}
    />
  ) : (
    <Loading />
  );
}
export default MagnetPage;
